import React from "react";
import ReactDOM from "react-dom/client";

import GlobalProviders from "./providers/GlobalProviders";

import { TrackedApp } from "./App";
import reportWebVitals from "./reportWebVitals";

import { msalInstance } from "./utils/authUtils";

// import css for MetreaUI v1
// import "@mmd/metrea-ui/dist/index.css";

import "./styles/App.css";
import "./styles/overrides.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<GlobalProviders instance={msalInstance}>
		<TrackedApp instance={msalInstance} />
	</GlobalProviders>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
